<template>
    <div class="card">
        <div class="card-body">
            <h3 class="card-title">Summary</h3>
            <div class="row mb-2 align-items-end">
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="form-group">
                        <label for="">Month</label>
                        <select name="" id="" class="form-select" v-model="filters.month">
                            <option :value="index" v-for="(month, index) in months" :key="index">{{ month }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="form-group">
                        <label for="">Year</label>
                        <select name="" id="" class="form-select" v-model="filters.year">
                            <option :value="year" v-for="year in years" :key="year">{{ year }}</option>
                        </select>

                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <button class="btn btn-block btn-primary" @click="loadReport">
                        Generate
                    </button>
                </div>
            </div>

            <hr>
            <!-- $headings = ['No.','Office','Fuel Type', 'Number of Liters', 'Actual Cost', 'Gas Station','Date & Time Filled','Date of Requested','Status']; -->

            <div class="table-responsive">
                <table class="table table-sm table-bordered mt-4">
                    <thead class="bg-primary text-center">
                        <tr>
                            <th class="text-white">#</th>
                            <th class="text-white">Office</th>
                            <th class="text-white">Liters</th>
                        </tr>
                    </thead>

                    <tbody v-if="isLoading">
                        <tr>
                            <td colspan="8" class="text-center">
                                <h3>Loading Please Wait...</h3>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row justify-content-end mt-2" v-if="items.length > 0">
                <div class="col-lg-3 col-md-4 col-sm-6 d-grid gap-2">
                    <button class="btn btn-block btn-success text-white" @click="exportReport">
                        Export
                    </button>
                    <a class="btn btn-block btn-primary text-white">
                        Download Summary
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            years: [],
            items: [],
            filters: {
                month: (new Date()).getMonth(),
                year: (new Date()).getFullYear(),
            },
            isLoading: false,
        }
    },
    methods: {
        async loadReport() {

            try {
                this.isLoading = true;
                const res = await axios.get('/pgo/reports/summary', {
                    params: {
                        month: this.filters.month + 1,
                        year: this.filters.year,
                    }
                });
                this.items = res.data;
                this.isLoading = false;

            }

            catch (e) {
                this.isLoading = false;
            }

        },
        loadYears() {
            let currentYear = new Date().getFullYear(); //get current year
            let endYear = 2022;
            let years = [];

            for (let i = currentYear; i >= endYear; i--) {
                years.push(i);
            }


            this.years = years;

            console.log(years);
        }
    },
    mounted() {
        this.loadYears();
    }
}
</script>